import React from "react";
import cx from "classnames";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import store from "store";
import { Hooks } from "@xt/xtbase";
const { useIntl, FormattedMessage } = Hooks;
import useIsDesktop from "@/hooks/useIsDesktop";
import AuthShell from "@/components/AuthShell";
import { getAbsoluteUrl } from "utils/method";

import style from "./index.module.less";
import AntAlert from "components/Antd/Alert";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";

export default observer(function ResetPassword() {
  const intl = useIntl();
  const router = useRouter();
  const { step = 1 } = router.query;
  const { isDark } = store.app;
  const themeStr = isDark ? "dark" : "light";
  const { isDesktop, isReady } = useIsDesktop();
  const isSpikexPc = isReady && isDesktop;

  const loginHref = getAbsoluteUrl({
    pathname: "/login",
    locale: router.locale,
    query: Object.fromEntries(Object.entries(router.query || {}).filter(([k]) => k !== "step")),
  });

  const stepContent = (
    <>
      {step == 1 && <StepOne />}
      {step == 2 && (
        <div className={style.stepTwo}>
          <StepTwo />
        </div>
      )}
      {step == 3 && <StepThree />}
    </>
  );

  const pageBody = isSpikexPc ? (
    <div className={cx(style.main, themeStr, style.spikexPc)}>
      <div className="left">
        {step != 2 && (
          <>
            <h1 className="iHead">
              {step == 1 && <FormattedMessage id="resetPwd.title" />}
              {step == 3 && <FormattedMessage id="resetPwd.titleSet" />}
            </h1>
            <p className="iDesc">{intl.formatMessage({ id: "resetPwd.tips" })}</p>
          </>
        )}
        {stepContent}
        {step != 2 && (
          <p className="iSubhead">
            <FormattedMessage
              id="register.isRegistered"
              values={{
                0: (
                  <a href={loginHref} className="iSubLink">
                    <FormattedMessage id="app.login" />
                  </a>
                ),
              }}
            />
          </p>
        )}
      </div>
    </div>
  ) : (
    <div className={cx(style.main, themeStr)}>
      {step != 2 && (
        <div className={style.pageAlert}>
          <AntAlert
            theme={themeStr}
            message={intl.formatMessage({ id: "resetPwd.tips" })}
            showIcon={true}
            type="warning"
          />
        </div>
      )}
      {step != 2 && (
        <h1 className={style.pageTitle}>
          {step == 1 && <FormattedMessage id="resetPwd.title" />}
          {step == 3 && <FormattedMessage id="resetPwd.titleSet" />}
        </h1>
      )}
      {stepContent}
    </div>
  );

  return <AuthShell>{pageBody}</AuthShell>;
});
